export const en = {
    'recall': 'Recall',
    'button-microphone-off': 'Turn off microphone',
    'button-microphone-on': 'Turn on camera',
    'button-camera-on': 'Turn on camera',
    'button-camera-off': 'Turn off camera',
};
